<template>

  <modal class="lg:min-w-[900px]" ref="modal" :modal-backdrop="true">
    <template #body>

      <h1 class="text-xl text-primary">
        {{
          uplodedData.type == 'description' ? 'Observações enviadas pelo paciente:' : 'Arquivos enviados pelo paciente:'
        }}
      </h1>


      <template v-if="uplodedData.type == 'description'">
        <ul
          v-for="des in uplodedData.descriptions"
          :key="des.id">
          <li class="text-base my-4 font-roboto" v-show="des.description">
            <span class="font-bold">Descrição:</span> {{ des.description }}
          </li>
        </ul>
      </template>


      <template v-else>
        <ul
          v-for="file in uplodedData.files">
          <li class="flex items-center justify-between my-4" v-show="file.name">
            <div class="flex-1">
              <div class="flex items-center justify-between lg:inline-block lg:mr-4">
                <div class="inline-block h-full">
                  <font-awesome-icon
                    icon="fa-file-image"
                    class="text-[30px] lg:text-[40px] text-purple-600"
                    v-if="file.extension == 'png' || file.extension == 'jpg'"/>

                  <font-awesome-icon
                    icon="fa-file-word"
                    class="text-[30px] lg:text-[40px] text-blue-600"
                    v-else-if="file.extension == 'doc' || file.extension == 'docx'"/>

                  <font-awesome-icon
                    icon="fa-file-pdf"
                    class="text-[30px] lg:text-[40px] text-red-600"
                    v-else-if="file.extension == 'pdf'"/>

                  <font-awesome-icon
                    icon="fa-file"
                    class="text-[30px] lg:text-[40px] text-gray-600"
                    v-else/>
                </div>

<!--                <inertia-link-->
<!--                  :href="`/pdf-view?link=${file.url}&type=${file.extension}`"-->
<!--                  target="_blank"-->
<!--                  class="inline-block lg:hidden w-10 h-10 text-center text-primary">-->
<!--                  <font-awesome-icon icon="fa-eye"/>-->
<!--                </inertia-link>-->
                <a
                  :href="`/pdf-view?link=${encodeURIComponent(file.url)}&type=${file.extension}`"
                  target="_blank"
                  rel="noopener"
                  class="inline-block lg:hidden w-10 h-10 text-center text-primary">
                  <font-awesome-icon icon="fa-eye" />
                </a>

              </div>

              <div class="inline-block h-full">
                <p class="text-base text-primary font-normal font-roboto">
                  {{ file.name }}
                </p>

                <p class="text-sm text-primary text-gray-500">
                  {{ new Date(file.created_at).toLocaleDateString('pt-BR') }} - {{
                    Number(file.size / 2024).toFixed(2)
                  }} MB
                </p>
              </div>
            </div>

<!--            <inertia-link-->
<!--              :href="`/pdf-view?link=${file.url}&type=${file.extension}`"-->
<!--              target="_blank"-->
<!--              class="hidden lg:inline-block w-10 h-10 text-center text-primary">-->
<!--              <font-awesome-icon icon="fa-eye"/>-->
<!--            </inertia-link>-->
            <a
              :href="`/pdf-view?link=${encodeURIComponent(file.url)}&type=${file.extension}`"
              target="_blank"
              rel="noopener"
              class="hidden lg:inline-block w-10 h-10 text-center text-primary">
              <font-awesome-icon icon="fa-eye" />
            </a>

          </li>
        </ul>
      </template>

      <button
        type="button"
        class="btn-primary float-right mt-4 font-normal uppercase"
        @click.prevent="closeModal">
        Fechar
      </button>
    </template>
  </modal>

</template>


<script>


import axios from 'axios'
import {Link} from '@inertiajs/inertia-vue3'

import Modal from './Modal.vue'


export default {


  components: {
    Modal,
    inertiaLink: Link,
  },

  expose: ['openModal'],


  data() {
    return {
      uplodedData: null,
    }
  },


  methods: {
    async openModal(appointment_id, filter = '') {

      await this.findFilesOfAppointment(appointment_id, filter)

      this.$refs.modal.open()
    },


    closeModal() {
      this.$refs.modal.close()
    },

    async findFilesOfAppointment(appointment_id, filter) {

      try {
        const response = await axios.get(`/appointment-uploads/${appointment_id}?filter=${filter}`)

        this.uplodedData = response.data
      } catch {

        this.$toast.error('Erro ao buscar documentos, tente novamente!')

      }

    }

  },

}


</script>
